import { render, staticRenderFns } from "./PlansCustomerForm.vue?vue&type=template&id=9c0096b4&scoped=true&"
import script from "./PlansCustomerForm.vue?vue&type=script&lang=js&"
export * from "./PlansCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0096b4",
  null
  
)

export default component.exports